import template from './addAdministrators.html';
import controller from './addAdministrators.controller';

let addAdministratorsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default addAdministratorsComponent;



// WEBPACK FOOTER //
// ./app/components/addAdministrators/addAdministrators.component.js